export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';

export const SHOW_PASSWORD_RESET_MODAL = 'SHOW_PASSWORD_RESET_MODAL';
export const HIDE_PASSWORD_RESET_MODAL = 'HIDE_PASSWORD_RESET_MODAL';
